import { ComponentClass } from 'react';
import { LazyAction, LazyImport, LazyModule, createLazyComponent } from 'owa-bundling';
import { runAfterInitialRender } from 'owa-delayed-initialization';

const getStartedLazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "GetStarted" */ './lazyIndex')
);

export { ComponentClass };

export let GetStartedList = createLazyComponent(getStartedLazyModule, m => m.GetStartedList);

export let initializeGetStartedTasksLazy = new LazyImport(
    getStartedLazyModule,
    m => m.getInitializeGetStartedPromise
);

export let enableGetStartedInListViewLazy = new LazyAction(
    getStartedLazyModule,
    m => m.enableGetStartedInListView
);

runAfterInitialRender(() => {
    initializeGetStartedTasksLazy
        .import()
        .then(getInitializeGetStartedPromise => getInitializeGetStartedPromise());
});
